document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-main-nav]');
  if (toggle && nav) toggle.addEventListener('click', () => nav.classList.toggle('open'));

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('.faq-item');
      item?.classList.toggle('open');
      button.setAttribute('aria-expanded', item?.classList.contains('open') ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-license-selector]').forEach((selector) => {
    const json = selector.querySelector('[data-variant-json]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch(e) { return; }
    const planButtons = [...selector.querySelectorAll('[data-plan]')];
    const termButtons = [...selector.querySelectorAll('[data-term]')];
    const idInput = selector.querySelector('[data-variant-id]');
    const price = selector.querySelector('[data-selected-price]');
    const label = selector.querySelector('[data-selected-label]');
    const submit = selector.querySelector('[data-license-submit]');
    const availability = selector.querySelector('[data-license-availability]');
    let plan = planButtons.find(b => b.classList.contains('active'))?.dataset.plan || 'Lite';
    let term = termButtons.find(b => b.classList.contains('active'))?.dataset.term || 'Day';
    const norm = (s) => { const v=(s || '').toString().trim().toLowerCase(); return v === 'year' ? 'yearly' : v; };

    function update() {
      const match = variants.find(v => norm(v.plan) === norm(plan) && norm(v.term) === norm(term));
      planButtons.forEach(b => b.classList.toggle('active', norm(b.dataset.plan) === norm(plan)));
      termButtons.forEach(b => b.classList.toggle('active', norm(b.dataset.term) === norm(term)));
      if (!match) {
        if (label) label.textContent = `${plan} / ${term}`;
        if (price) price.textContent = 'Not configured';
        if (submit) { submit.disabled = true; submit.textContent = 'Variant not configured'; }
        if (availability) { availability.classList.remove('in-stock'); availability.textContent = 'Create this Shopify variant to enable checkout'; }
        return;
      }
      if (idInput) idInput.value = match.id;
      if (label) label.textContent = match.title;
      if (price) price.textContent = match.price;
      if (submit) { submit.disabled = !match.available; submit.textContent = match.available ? 'Add license to cart' : 'Unavailable'; }
      if (availability) { availability.classList.toggle('in-stock', !!match.available); availability.textContent = match.available ? 'Digital license available' : 'This option is unavailable'; }
    }
    planButtons.forEach(b => b.addEventListener('click', () => { plan = b.dataset.plan; update(); }));
    termButtons.forEach(b => b.addEventListener('click', () => { term = b.dataset.term; update(); }));

    // If current Shopify variant matches one of the 12 expected combinations, start there.
    const current = variants.find(v => String(v.id) === String(idInput?.value));
    if (current && ['lite','basic','pro'].includes(norm(current.plan)) && ['day','week','month','yearly'].includes(norm(current.term))) { plan = current.plan; term = current.term; }
    update();
  });
});

// Predator duration selector: maps directly to real Shopify variant IDs.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-predator-selector]').forEach((selector) => {
    const buttons = Array.from(selector.querySelectorAll('[data-predator-id]'));
    const input = selector.querySelector('[data-predator-variant-id]');
    const price = selector.querySelector('[data-selected-predator-price]');
    const selected = selector.querySelector('[data-predator-selected]');
    const submit = selector.querySelector('[data-predator-submit]');
    const status = selector.querySelector('[data-predator-status]');
    function select(button) {
      if (!button || button.disabled) return;
      buttons.forEach((b) => {
        const active = b === button;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', String(active));
      });
      if (input) input.value = button.dataset.predatorId;
      if (price) price.textContent = button.dataset.predatorPrice;
      if (selected) selected.textContent = button.dataset.predatorDuration;
      const available = button.dataset.predatorAvailable === 'true';
      if (submit) { submit.disabled = !available; submit.textContent = available ? (submit.dataset.addLabel || 'Add license to cart') : 'Unavailable'; }
      if (status) { status.classList.toggle('in-stock', available); status.textContent = available ? 'Digital package available' : 'This duration is unavailable'; }
      // Update selected variant URL without overriding existing path.
      try {
        const url = new URL(location.href);
        url.searchParams.set('variant', button.dataset.predatorId);
        history.replaceState({}, '', url.toString());
      } catch (_) { /* URL change is optional */ }
    }
    buttons.forEach((b) => b.addEventListener('click', () => select(b)));
    const qs = new URLSearchParams(location.search);
    const requested = qs.get('variant');
    const initial = buttons.find(b => requested && b.dataset.predatorId === requested && !b.disabled)
      || buttons.find(b => b.classList.contains('active') && !b.disabled)
      || buttons.find(b => !b.disabled);
    // Avoid rewriting the URL on load.
    if (initial) {
      buttons.forEach(b => { const a=b===initial;b.classList.toggle('active',a);b.setAttribute('aria-pressed',String(a)); });
      if (input) input.value=initial.dataset.predatorId;
      if (price) price.textContent=initial.dataset.predatorPrice;
      if (selected) selected.textContent=initial.dataset.predatorDuration;
    }
  });
});
